import styled from 'styled-components/macro';
import { grey50 } from 'variables/colors';
import { border, borderRadius } from 'variables/general';

export const Component = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1em;
  border: ${border};
  border-radius: ${borderRadius};
  cursor: pointer;

  &:not(:last-of-type) {
    margin-bottom: 1.5em;
  }

  &:hover {
    border: 1px solid ${grey50};
  }
`;

export const CoreInfo = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: ${({ contactInfoAvailable }) =>
    contactInfoAvailable && '1em'};
  border-bottom: ${({ contactInfoAvailable }) =>
    contactInfoAvailable && border};
`;

export const NameContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.75em;
`;

export const Name = styled.h5`
  margin-right: 1em;
`;

export const LeftContainer = styled.div`
  flex-grow: 1;
`;

export const Address = styled.h6`
  margin-bottom: 0.5em;
  color: ${grey50};
`;

export const Details = styled.div`
  display: flex;
  padding-top: 1em;
`;

export const Detail = styled.h6`
  &:not(:last-of-type)::after {
    padding: 0 1em;
    content: '|';
  }
`;
